import gql from 'graphql-tag'

export const COMMISSION_DISTRIBUTION_RULE_SET_DELETE_MUTATION = gql`
    mutation commissionDistributionRuleSetDelete(
        $id: ID!
    ) {
        commissionDistributionRuleSetDelete(
            id: $id
        ) {
            status
        }
    }
`
